import { buildLoginUrl } from '@pickleballinc/lib/session/login-url';

import { publicEnv } from '@/lib/env';
import { IS_LOCALHOST } from '@/utils/helpers/constants';

/** A "Log in" link or redirect: SSO's login, or the local `/login` on localhost. See `buildLoginUrl`. */
export const getLoginUrl = (continueTo?: string | URL) =>
  buildLoginUrl({ ssoUrl: publicEnv.NEXT_PUBLIC_SSO_URL, isLocalhost: IS_LOCALHOST, continueTo });
